import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/services/common-services/common.service';
import { environment } from 'src/environments/environment';
import { ConfirmationBoxComponent } from 'src/app/shared/elements/confirmation-box/confirmation-box.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-pre-register',
  templateUrl: './pre-register.component.html',
  styleUrls: ['./pre-register.component.scss']
})
export class PreRegisterComponent {
  userForm!: FormGroup;
  event: any;
  portalUrl = environment.PORTAL_URL;
  eventParams:any;

  constructor(
    public dialog: MatDialog,
    private fb: FormBuilder, 
    private router: Router, 
    private route:ActivatedRoute,
    private service:CommonService) {}
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.event = params['event'];
    });  
    this.createUserType();
    //this.setData();
    this.getEventData();
  }
  // setData(): void {
  //   this.service.setEventParams(this.event);
  // }
  createUserType() {
    this.userForm = this.fb.group({
      userType: new FormControl('', Validators.required) 
    })
  }
  isValid() {
    if (this.userForm.controls['userType'].status === 'INVALID')  {
      return true;
    } else {
      return false;
    }
  }
  getEventData() {
    // event tracking for supplier registration
    this.eventParams = localStorage.getItem('event');
  }
  onSubmit() {
    if(this.userForm.value.userType == 1){
      this.router.navigate(["/registration"]);
    } else if(this.userForm.value.userType == 2){
      let redirectUrl:any = this.eventParams ? `${this.portalUrl}supplier/registration/event?name=${this.eventParams}` : `${this.portalUrl}supplier/registration`;
      this.openRedirectionConfirmation(redirectUrl);
      if (localStorage.getItem('event')) {
        localStorage.removeItem('event');
      }
      //window.open(`${this.portalUrl}supplier/registration`, '_blank');
    }else if(this.userForm.value.userType == 3){
      let redirectUrl:any = this.eventParams ? `${this.portalUrl}supplier/service-partner/registration/event?name=${this.eventParams}` : `${this.portalUrl}supplier/service-partner/registration`;
      this.openRedirectionConfirmation(redirectUrl);
      if (localStorage.getItem('event')) {
        localStorage.removeItem('event');
      }
      //window.open(`${this.portalUrl}supplier/service-partner/registration`, '_blank');
    }
  }
  openRedirectionConfirmation(redirectUrl:string){
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      //width: '50%',
      data: {
        //heading: 'You are being redirected to Unibuild Supplier Portal.',
        cssClass: 'redirectCnt',
        content: `You are being redirected to Unibuild Supplier Portal.`,
        btnConfirm: 'OK',
        btnCancel: 'Cancel',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        //console.log(result, "Result");
        window.open(redirectUrl, '_blank');
      } 
    });
  }
}
